export const DEFAULT_HEADER_IMAGE = "https://static.prodeko.org/media/ilmo/default-header-image.jpg";
//# sourceMappingURL=constants.js.map